/*
 * @Author: chenlin
 * @Date: 2020-04-08 09:00:36
 * @LastEditors: lzq
 * @LastEditTime: 2023-11-01 16:56:43
 * @Description: 在此添加描述
 */
import store from '@/store'
/**
 * 按钮权限判断
 * @param value 按钮的编码
 * @returns {boolean}
 */
export function btnsPermission (code) {
  let flag = false

  const btnList = JSON.parse(sessionStorage.getItem('btnList'))
  if (btnList) {
    for (const item of btnList) {
      if (item.perms === code) {
        flag = true
      }
    }
  }
  return flag
}
